import React, {useCallback, useEffect} from 'react';
import {Location} from '@reach/router';
import ABTest, {DebugMenu} from 'react-controlled-ab';
import {subscribeToCampaign} from 'react-controlled-ab/datalayers/vwo';
import {Col, Container, Row} from 'reactstrap';
import {usePhaseState} from 'funnel-schedule/phase-context';
import PageMeta from 'components/PageMeta';
import Header from 'components/Elements/Header';
import QuizForm from 'components/Forms/QuizForm';
import Footer from 'components/Elements/Footer';

export default function QuizIndex() {
  const {
    phases: {
      default: defaultSchedule = {
        phase: 'before',
        launchStart: '',
        launchEnd: '',
        launchTitle: ''
      }
    }
  } = usePhaseState();

  const shareUrl = 'https://brain.foodrevolution.org/quiz/';
  const shareImg = 'https://cdn.foodrevolution.org/hbc/og/hbc-social-assets-quiz-open-graph-20210212-1200x630px.jpg';
  const facebookDescription =
    'Recent neuroscience breakthroughs are turning conventional brain beliefs on their head. Do you know about the latest discoveries? Test your knowledge when you take the quiz here:';
  const twitterDescription =
    'Our brains are pretty powerful. Join me and test your knowledge on the latest #BrainBreakthroughs! Take the quiz here:';
  const pinterestDescription = 'How much do you know about the latest brain breakthroughs? Take the quiz here:';
  const pinterestImg =
    'https://cdn.foodrevolution.org/hbc/og/hbc-social-assets-quiz-open-graph-20210212-1200x1500px.jpg';

  return (
    <>
      <PageMeta
        title="Take the Brain Health Quiz"
        description="How much do you know about brain health? Take the Brain Health Quiz and find out."
        url={shareUrl}
        ogImage={shareImg}
      />

      <div className="quiz-background fullsize background-cover background-fixed background-image-center">
        <div className="page page-noscocial quiz-page d-flex flex-column">
          <Header
            bgColor="purple"
            lockupWhite
            shareUrl={shareUrl}
            shareImg={shareImg}
            facebookDescription={facebookDescription}
            twitterDescription={twitterDescription}
            pinterestDescription={pinterestDescription}
            pinterestImg={pinterestImg}
          />
          <Container className="quiz-container">
            <Row className="d-flex justify-content-center">
              <Col xs="12" lg="8" className="p-0">
                <div className="quiz-box background-white rounded">
                  <div className="quiz-copy text-center">
                    <Row className="mb-4">
                      <Col>
                        <h2 className="section-heading">
                          How much do <br className="d-none d-lg-block d-xl-none" />
                          you <br className="d-none d-sm-block d-lg-none" />
                          know about <br className="d-none d-lg-block d-xl-none" />
                          brain health?
                        </h2>
                        <p>Your brain weighs only 3 pounds.</p>
                        <p>
                          And in these 3 pounds, you have <br className="d-none d-sm-block" />
                          more than <strong>87 billion neurons!</strong>
                        </p>
                        <p className="mb-0">
                          Do you know what it takes to keep your <br className="d-none d-sm-block" />
                          most vital organ smart and healthy?
                        </p>
                      </Col>
                    </Row>
                  </div>
                  <div className="quiz-form">
                    <QuizForm />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          <div className="footer-content mt-auto mt-lg-0">
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}
